import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { getAuftraegeCSV } from '../../../redux/actions/auftrag';
import { isoDateIsValid, isoDateToDate } from '../../../utils/date';
import Button from '../../../components/button/Button';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import InputFieldText from '../../../components/input/floating-label/input-field/InputFieldText';
import { StateModel } from '../../../redux/store';
import { ConfigModel } from '../../../models/ConfigModel';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { setNotification } from '../../../utils/notificationUtils';

interface AuftragsexportProps {
  auftragsResearch: any;
  getAuftraegeCSV: any;

  config: ConfigModel;

  currentMandantId: string;
}

/**
 * Auftragsresearch-Component
 * Dient zum Export von Aufträgen in CSV-Datei
 *
 * @returns {JSX.Element} Auftragsresearch-Component
 * @constructor
 */
const Auftragsexport = ({
  getAuftraegeCSV,
  auftragsResearch,

  currentMandantId,
}: AuftragsexportProps & RouteComponentProps) => {
  const [dateFrom, setDateFrom] = useState<string>(
    isoDateToDate(
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 2)
    )
  );
  const [dateTo, setDateTo] = useState<string>(
    isoDateToDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
  );

  const checkValidDates = () => {
    return (
      isoDateIsValid(dateFrom) && isoDateIsValid(dateTo) && dateFrom <= dateTo
    );
  };

  const ladeDaten = () => {
    const searchMandantID =
      currentMandantId ?? auftragsResearch.mandant?.id ?? undefined;
    if (checkValidDates()) {
      getAuftraegeCSV(
        isoDateToDate(dateFrom),
        isoDateToDate(dateTo),
        searchMandantID
      );
    } else {
      setNotification(' Bitte korrigieren Sie die Angaben des Zeitraumes.', []);
    }
  };

  return (
    <Fragment>
      <div className='auftragsexport-wrapper '> </div>

      <GridCellWrapper
        classes='auftragsexport'
        label='Monatlicher CSV-Export'
        saveUserAnsicht={() => {
          null;
        }}
      >
        <label>{'bitte Zeitraum angeben: '}</label>
        <div className={'datediv'}>
          <InputFieldText
            label='Datum von'
            classes='date'
            inputType='date'
            onChangeHandler={setDateFrom}
            value={dateFrom}
          />
          <InputFieldText
            label='Datum bis'
            classes='date'
            inputType='date'
            onChangeHandler={setDateTo}
            value={dateTo}
          />
        </div>
        <Button
          tooltip='Auftrag als CSV exportieren'
          key={1}
          classes={'export'}
          onClickHandler={() => {
            ladeDaten();
          }}
        >
          Aufträge als CSV exportieren
        </Button>
        <label className={'auexportlabel'}>
          Bitte beachten Sie, dass die Anfrage einige Minuten dauern kann.
        </label>
        <progress
          max={auftragsResearch.csvExportCount}
          value={auftragsResearch.csvExportDone}
        ></progress>
        <label className={'auexportstatus'}>
          {auftragsResearch.csvExportDone} / {auftragsResearch.csvExportCount}
        </label>
      </GridCellWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragsResearch: state.Auftraege,
  config: state.Config,
  currentMandantId: state.UserSession.currentMandantId,
});

export default connect(mapStateToProps, {
  getAuftraegeCSV,
})(withRouter(Auftragsexport));
